import { DEVELOPMENT_MODE, ENVIRONMENT } from '../constants';

export function isDevelopment(): boolean {
    return !ENVIRONMENT || ENVIRONMENT === 'development' || DEVELOPMENT_MODE === '1';
}

export const getBffUrl = (host: string): string => {
    if (host.includes('localhost')) {
        return 'https://localhost:44357';
    }

    const newHostUri = host.replace('calcreview', 'calcreview-api');
    return `https://${newHostUri}`;
};

export const getCalculationReviewUrl = (host: string): string => {
    if (host.includes('localhost')) {
        return 'http://localhost:3000/';
    }

    return `https://${host}/`;
};

export const getAnalyticsUrl = (host: string): string => {
    if (host.includes('localhost')) {
        return 'https://localhost:3002/';
    }

    const newHostUri = host.replace('calcreview', 'analytics');
    return `https://${newHostUri}`;
};
